import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TokenStorageService } from './token-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private _isAuthenticated$ = new BehaviorSubject<boolean>(false);
  public readonly isAuthenticated$ = this._isAuthenticated$.asObservable();

  constructor(private tokenStorage: TokenStorageService, private zone: NgZone) {
    // Initialize from storage on service creation
    this._isAuthenticated$.next(!!this.tokenStorage.getToken());

    // Listen to cross-tab updates (login/logout in another tab)
    window.addEventListener('storage', (event: StorageEvent) => {
      if (!event.key || (event.key !== 'auth-token' && event.key !== 'auth-user')) return;
      // Run inside Angular zone to trigger change detection
      this.zone.run(() => {
        const hasToken = !!this.tokenStorage.getToken();
        this._isAuthenticated$.next(hasToken);
      });
    });
  }

  notifyLogin() {
    this._isAuthenticated$.next(true);
  }

  notifyLogout() {
    this._isAuthenticated$.next(false);
  }
}
